/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../constants/ServiceConstants';
import utils from '../../../../common/utils';

export default class GetTargetTenantsService extends BaseService {
  constructor() {
    super(constants.GET_TARGET_TENANTS, 'targetTenantsListStatus');
  }

  async handleEvent(eventName, event) {
    const { targetEnv } = event;
    const { headers } = utils.buildRequestPartsFromPayload(event);

    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient('aiadminstackb').get(`/tenants/${targetEnv}/list`, { headers: enhancedHeaders });
    }
    return this.getClient('aiadmin').get(`/tenants/${targetEnv}/list`, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    const tenantState = Framework.getStoreRegistry().getStore('tenantState');
    const tenantsList = data?.data || data;

    if (Array.isArray(tenantsList)) {
      tenantState.setTargetTenantList(tenantsList);
    } else {
      const notification = {
        open: true,
        langMessage: 'targetTenants.INVALID_RESPONSE_FORMAT',
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
  }

  handleError(error) {
    const { response } = error;
    if (response) {
      const { status } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
    }

    const notification = {
      open: true,
      langMessage: 'targetTenants.FETCH_ERROR',
      type: 'error'
    };
    Framework.getStoreRegistry().getStore('notificationState').set(notification);
  }
}
